<mat-spinner [diameter]="spinnerSize" color="accent"></mat-spinner>
